import { createContext, useContext } from "react";
import { useCheckClaimsWeb } from "../hooks/useCheckClaimsWeb";
import { ScreenType } from "../renderers/rendererLocator";
import { useViewedUserId } from "feat/viewedUser/viewedUser";

interface IScreenTypeContext {
  screenType: ScreenType;
  overridden: boolean;
  openDisclosure?: boolean;
  stickyHeaders?: boolean;
}

const ScreenTypeContext = createContext<IScreenTypeContext>({
  screenType: "personal",
  overridden: false,
});
interface IScreenTypeProps {
  children: React.ReactNode;
  screenType: ScreenType;
  openDisclosure?: boolean;
  stickyHeaders?: boolean;
}
export const ScreenTypeProvider = (props: IScreenTypeProps) => {
  const effectiveType = useEffectiveScreenType(props.screenType);
  return (
    <ScreenTypeContext.Provider
      value={{
        screenType: effectiveType,
        overridden: effectiveType !== props.screenType,
        openDisclosure: props.openDisclosure,
        stickyHeaders: props.stickyHeaders ?? true,
      }}
    >
      {props.children}
    </ScreenTypeContext.Provider>
  );
};
export const useScreenTypeContext = () => {
  return useContext(ScreenTypeContext);
};

export function useEffectiveScreenType(inputScreenType?: ScreenType): ScreenType {
  const viewedUserId = useViewedUserId();
  const contextScreenType = useScreenTypeContext().screenType;

  const screenType = inputScreenType ?? contextScreenType;

  const canViewPrivateEntries = useCheckClaimsWeb(["/"], ["userPrivateEntryViewer"]);

  if (screenType === "teamMember" && viewedUserId !== null && canViewPrivateEntries) {
    return "upNext";
  }
  return screenType;
}
